import {
  INITIAL_RECORDING_SNAPSHOT,
  type RecordingSnapshot,
  stateManager,
} from './project-usability-recording-state-manager';

export const getServerRecordingSnapshot = (): RecordingSnapshot =>
  INITIAL_RECORDING_SNAPSHOT;

export function subscribeRecordingStart(onStart: () => void) {
  let wasRecording = stateManager.getSnapshot().isRecording;
  if (wasRecording) {
    onStart();
  }
  return stateManager.subscribe(() => {
    const { isRecording } = stateManager.getSnapshot();
    if (isRecording && !wasRecording) {
      onStart();
    }
    wasRecording = isRecording;
  });
}
